import { useState } from "react";
import { useAuthStore } from "../../auth/hooks";
import { useForm } from "../../hooks";
import { AuthLayout } from "../layout";
import { InputForm, LoadingData, ErrorMessage, MainButton } from "../ui";
import { useFormMessages } from "../hooks";

const formData = {
  code: "",
  password: "",
  confirmPassword: "",
};

const formValidations = {
  code: [(value) => value.length > 5, "El codigo debe ser mayor a 5 digitos"],
  password: [
    (value) => value.length >= 8,
    "La clave debe ser minima de 8 caracteres",
  ],
  confirmPassword: [
    (value) => value.length >= 8,
    "La clave debe ser minima de 8 caracteres",
  ],
};

export const ConfirmCodePasswordSection = () => {
  // Datos del hook ----------------------------------------//
  const {
    // Props
    isLoading,
    message,

    // Methods
    startConfirmResetPassword,
  } = useAuthStore();

  // States ------------------------------------------------//
  const [validateForm, setValidateForm] = useState(false);

  // Formulario --------------------------------------------//
  const { formState, formValidation, onInputChange, isFormValid } = useForm(
    formData,
    formValidations
  );

  const { setFormSubmitted, showErrorMessage, messageText } = useFormMessages({
    message,
    setValidateForm,
  });

  // Funciones ---------------------------------------------//
  const onSendCode = (event) => {
    event.preventDefault();
    setValidateForm(true);
    if (isFormValid) {
      setFormSubmitted(true);
      startConfirmResetPassword(formState);
    }
  };

  // Efectos -----------------------------------------------//

  return (
    <AuthLayout>
      <h4 className="text-center">Confirmar código</h4>
      <form className="login-form" onSubmit={onSendCode}>
        <div className="row g-3">
          {/* Formulario estatico */}
          <>
            <div className="col-md-12">
              <InputForm
                label={
                  "Digita el código de verificación enviado a tu correo electronico"
                }
                type={"text"}
                validation={formValidation.codeValid}
                submit={validateForm}
                name={"code"}
                value={formState.code}
                onInputChange={onInputChange}
              />
            </div>
            <div className="col-md-12">
              <InputForm
                label={"Digita tu nueva contraseña"}
                type={"password"}
                validation={formValidation.passwordValid}
                submit={validateForm}
                name={"password"}
                value={formState.password}
                onInputChange={onInputChange}
              />
            </div>
            <div className="col-md-12">
              <InputForm
                label={"Confirma tu nueva contraseña"}
                type={"password"}
                validation={formValidation.confirmPasswordValid}
                submit={validateForm}
                name={"confirmPassword"}
                value={formState.confirmPassword}
                onInputChange={onInputChange}
              />
            </div>
          </>

          <div className="col-md-12">
            <div className="d-grid">
              <MainButton type="submit" disabled={isLoading}>
                Enviar
              </MainButton>
            </div>
          </div>

          {/* Mensajes */}
          <>
            {isLoading && (
              <div className="col-md-12">
                <LoadingData />
              </div>
            )}
            {showErrorMessage && (
              <div className="col-md-12">
                <ErrorMessage>{messageText}</ErrorMessage>
              </div>
            )}
          </>
        </div>
      </form>
    </AuthLayout>
  );
};
